/** Специальные виджеты  (Визуальные компоненты) для редактирования элементов (полей в карточке) DCAT каталога 
 * Параметрами является:
 * 1. uri - отображаемое свойства (predicate);
 * 2. value - начальное значение
 * 3. ...props - дополнительные параметры из которых формируются прараметры для Form.Item и вложенного Input
*/
import React from 'react';
import { Select } from 'antd';
import { DefaultFormItem, DateFormItem, NumberFormItem, TextAreaFormItem, 
  SwitchFormItem, SelectUriFormItem} from '../widgets/FormItemInputs';

//
//Визуальные компоненты для ввода/редактирования полей в карточке DCAT каталога и его элементов
//

/**
 *  Компонент по умолчанию. Стандартный Input в оболочке Form.Item
 */
export const DefaultEditor = ({uri, value, ...props}) => {
  //console.log("AssetInputs.js DefaultFormItem", uri, value);
  return (
    <DefaultFormItem uri={uri} value = {value}  {...props}/>
  )
}


export const URLEditor = ({uri, value, ...props}) => {
  //console.log("AssetInputs.js URLEditor", uri, value);
  return (
    <DefaultFormItem uri={uri} value = {value}  {...props}/>
  )
}

export const DateEditor = ({uri, value, ...props}) => {
  console.log("AssetInputs.js DateEditor", uri, value, props);
  return (
    <DateFormItem uri={uri} value = {value} {...props}/>
  )
}

export const NumberPositiveEditor = ({uri, value, ...props}) => {
  //console.log("AssetInputs.js NumberPositiveEditor", uri, value);
  return (
    <NumberFormItem uri={uri} value = {value} min={0}  {...props}/>
  )
}

const selectAfter = (
  <Select defaultValue="" style={{ width: 110, display: 'none' }}>
    <Option value="">байт</Option>
    <Option value="Kb">Кб</Option>
    <Option value="MB">Мб</Option>
    <Option value="G">Гб</Option>
  </Select>
);

export const ByteSizeEditor = ({uri, value, ...props}) => {
  return (
    <NumberFormItem uri={uri} value = {value} min={0}  {...props} addonAfter={selectAfter}/>
  )
}


export const DescriptionEditor = ({uri, value, ...props}) => {
  //console.log("AssetInputs.js DescriptionEditor", uri, value, );
  return (
    <TextAreaFormItem uri={uri} value = {value} rows={4}  {...props}/>
  )
}

export const SwitchEditor = ({uri, value, ...props}) => {
  return (
    <SwitchFormItem uri={uri} value = {value}  {...props}/>
  )
}

export const SelectUriEditor = ({uri, value, ...props}) => {
  return (
    <SelectUriFormItem uri={uri} value = {value} {...props}/>
  )
}

